import { render, staticRenderFns } from "./AssistSlicerPreview.vue?vue&type=template&id=2daddeb1&scoped=true"
import script from "./AssistSlicerPreview.vue?vue&type=script&lang=js"
export * from "./AssistSlicerPreview.vue?vue&type=script&lang=js"
import style0 from "./AssistSlicerPreview.vue?vue&type=style&index=0&id=2daddeb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daddeb1",
  null
  
)

export default component.exports